import React from 'react';
import cx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'types';

interface ModalContainerProps {
  Header?: JSX.Element;
  Footer?: JSX.Element;
  className?: string;
  children?: React.ReactNode;
}

export const ModalContainer = ({ Header, Footer, children, className }: ModalContainerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {Header}
      <div className={cx(classes.body, Footer && classes.withFooter, className)}>{children}</div>
      {Footer}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 90000
  },
  body: { overflow: 'auto' },
  withFooter: {
    height: `calc(100% - ${theme.constants.modals.footerHeight}px)`
  }
}));

export default ModalContainer;
